import React, { useContext } from "react";
import { CommonContext } from "../hooks/CommonContext";
import { FaVideo, FaVideoSlash } from "react-icons/fa";

const CameraToggleButton = () => {
  const { toggleVideo, userOwnData } = useContext(CommonContext);
  return (
    <button
      onClick={toggleVideo}
      title={userOwnData.isCameraOn ? "Turn off camera" : "Turn on camera"}
      className={`ftr-btn${!userOwnData.isCameraOn ? " ftr-off" : ""}`}
    >
      {userOwnData.isCameraOn ? <FaVideo /> : <FaVideoSlash />}
    </button>
  );
};

export default CameraToggleButton;